export enum MatchAnalysisStateEnum {
  NotStarted= 'NotStarted',
  InProgress = 'InProgress',
  Validated = 'Validated',
  Classified = 'Classified'
}

export const allMatchAnalysisStates = Object.keys(MatchAnalysisStateEnum);
